module.exports = __webpack_public_path__ + "img/e8a9bac.png";